import { getStockLevel } from "../helper/products";

  const config = {
    IN: {
      label: "In Stock",
      color: "#22c55e", // green-500
    },
    LOW: {
      label: "Low",
      color: "#facc15", // yellow-400
    },
    NONE: {
      label: "Out of Stock",
      color: "#000000"
    }
  };

export function StockStatusIndicator({ quantity = 0, type = "SINGLE"}) {
  const status = getStockLevel(quantity, type);

  const { label, color } = config[status];

  return (
    <div
      className="stock-indicator"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontWeight: 100,
      }}
    >
      <span
        style={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: color,
        }}
      />
    </div>
  );
}


export default function StockIndicator({ quantity = 0, type = "SINGLE", priceText = "" }) {
  const status = getStockLevel(quantity, type);

  const { label, color } = config[status];

  return (
    <div
      className="stock-indicator"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        fontWeight: 100,
        // color: color
      }}
    >
      <StockStatusIndicator quantity={quantity} type={type}/>
      {priceText ? (
        <div className="column flex-start">
          <p>From</p>
          {`$${priceText}`}
        </div>
      ) : null}

    </div>
  );
}

